import { useFormik } from "formik";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { Card, CardBody, Col, Container, Form, Row } from "reactstrap";
import showNofity from "../../helpers/toast";
import ModalLoding from "../../Components/Common/ModalLoading";

import * as Yup from "yup";

import BreadCrumb from "../../Components/Common/BreadCrumb";
import states from "../../utils/states.json";

import UiContent from "../../Components/Common/UiContent";
import {
  CoverUploadImageField,
  InputMask,
  TextField,
} from "../../Components/Forms";
import Loading from "../../Components/Loading/Loading";
import { getCitiesRequest } from "../../store/city/actions";
import { createStoreRequest } from "../../store/stores/actions";
import { isLatitude, isLongitude } from "../../utils/formats";
import { forceNumericCoordinate } from "../../utils/coordinates";

const StoreForm = () => {
  document.title = "Lojas | Ecoguias - Admin Dashboard";
  const dispatch = useDispatch();

  const { loading } = useSelector((state) => state.Store);
  const { data: dataCity, loading: loadingCity } = useSelector(
    (state) => state.City
  );

  const history = useHistory();

  useEffect(() => {
    dispatch(getCitiesRequest());
  }, [dispatch]);

  const hotel = useFormik({
    enableReinitialize: true,

    initialValues: {
      nome: "",
      telefones: "",
      logradouro: "",
      numero: "",
      bairro: "",
      cidade: "",
      estado: "",
      images: [],
      url_video: "",
      whatsapp: "",
      instagram: "",
      descritivo: "",
      url_site: "",
      email: "",
      latitude: "",
      longitude: "",
      // pet_friendly: "",
      imagem_principal: 0,
    },

    validationSchema: Yup.object({
      nome: Yup.string().required("Este campo é obrigatório"),
      descritivo: Yup.string().required("Este campo é obrigatório"),
      url_video: Yup.string().optional(),
      telefones: Yup.string(),
      logradouro: Yup.string(),
      numero: Yup.string(),
      bairro: Yup.string(),
      cidade: Yup.string().required("Este campo é obrigatório"),
      estado: Yup.string(),
      images: Yup.array(Yup.string()),
      whatsapp: Yup.string().optional(),
      instagram: Yup.string().optional(),
      url_site: Yup.string().optional(),
      email: Yup.string(),
      latitude: Yup.string()
        .nullable()
        .test("is-latitude", "Insira uma latitude válida", (value) =>
          value ? isLatitude(value) : true
        ),
      longitude: Yup.string()
        .nullable()
        .test("is-longitude", "Insira uma longitude válida", (value) =>
          value ? isLongitude(value) : true
        ),
      // .required("Este campo é obrigatório"),
      // pet_friendly: Yup.boolean().required("Este campo é obrigatório"),
    }),
    onSubmit: async (values, { resetForm }) => {
      if (values.images.length < 1) {
        showNofity.error("Selecione uma imagem");
        return;
      }

      // values.pet_friendly = String(values.pet_friendly) === "true";
      values.latitude = forceNumericCoordinate(values.latitude);
      values.longitude = forceNumericCoordinate(values.longitude);

      dispatch(createStoreRequest({ values, resetForm }));
    },
  });

  return (
    <React.Fragment>
      <ToastContainer />
      <UiContent />
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Formulário de lojas" pageTitle="Lojas" />
        </Container>
        <Col lg={12}>
          <Card>
            <div className="p-4">
              <button
                className="btn btn-primary"
                onClick={() => history.goBack()}
              >
                Voltar
              </button>
            </div>

            <CardBody>
              <div className="live-preview">
                <Form
                  className="needs-validation"
                  onSubmit={(e) => {
                    e.preventDefault();
                    hotel.handleSubmit();
                    return false;
                  }}
                  action="#"
                >
                  <Row className="g-3">
                    <TextField label="Nome" name="nome" data={hotel} />

                    <InputMask
                      type="phone-br"
                      label="Telefone"
                      name="telefones"
                      data={hotel}
                      size={6}
                    />

                    <TextField
                      label="Logradouro"
                      name="logradouro"
                      data={hotel}
                    />

                    <TextField
                      label="Número"
                      size={2}
                      name="numero"
                      data={hotel}
                    />
                    <TextField
                      label="Bairro"
                      size={4}
                      name="bairro"
                      data={hotel}
                    />

                    <TextField
                      label="Cidade"
                      name="cidade"
                      type="select"
                      data={hotel}
                    >
                      <option value="" disabled selected>
                        Selecione uma cidade
                      </option>
                      {dataCity?.result?.length > 0
                        ? dataCity?.result.map((item, index) => (
                            <option key={index} value={item.objectId}>
                              {item.nome}
                            </option>
                          ))
                        : undefined}
                    </TextField>

                    <TextField
                      label="Estado"
                      name="estado"
                      type="select"
                      data={hotel}
                      size={2}
                    >
                      <option value="" disabled selected>
                        Selecione um estado
                      </option>

                      {states.map(({ sigla, id_uf }) => (
                        <option key={id_uf} value={sigla}>
                          {sigla}
                        </option>
                      ))}
                    </TextField>

                    <TextField
                      label="Latitude"
                      name="latitude"
                      data={hotel}
                      size={2}
                      type="number"
                      onKeyDown={(event) => {
                        ["e", "E", "+", ","].includes(event.key) &&
                          event.preventDefault();
                      }}
                    />

                    <TextField
                      label="Longitude"
                      name="longitude"
                      data={hotel}
                      size={2}
                      type="number"
                      onKeyDown={(event) => {
                        ["e", "E", "+", ","].includes(event.key) &&
                          event.preventDefault();
                      }}
                    />

                    <TextField
                      label="Vídeo do local (URL)"
                      name="url_video"
                      data={hotel}
                    />

                    <TextField
                      label="Site"
                      name="url_site"
                      data={hotel}
                      size={6}
                    />

                    <TextField label="E-mail" name="email" data={hotel} />

                    <InputMask
                      type="phone-br"
                      label="WhatsApp"
                      name="whatsapp"
                      data={hotel}
                      size={6}
                    />

                    <TextField
                      label="Instagram"
                      name="instagram"
                      data={hotel}
                    />

                    {/* <TextField
                      type="select"
                      label="PETs Friendly"
                      name="pet_friendly"
                      data={hotel}
                    >
                      <option value="" selected disabled>
                        Selecione uma opção
                      </option>
                      <option value={true}>Sim</option>
                      <option value={false}>Não</option>
                    </TextField> */}

                    <TextField
                      size={12}
                      type="textarea"
                      label="Descrição"
                      name="descritivo"
                      data={hotel}
                    />

                    <CoverUploadImageField
                      title="Imagens do local"
                      multiple
                      data={hotel}
                      name="images"
                    />

                    <Col lg={12}>
                      <div className="text-end">
                        <button type="submit" className="btn btn-primary">
                          Salvar
                        </button>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </div>
            </CardBody>
          </Card>
        </Col>
      </div>
      <ModalLoding loading={loading} />
    </React.Fragment>
  );
};

export default StoreForm;
